export default "__VITE_ASSET__DOEC8ski__"